import { useEffect } from "react";

export const TermlyScript = () => {
  useEffect(() => {
    const configScript = document.createElement("script");
    configScript.setAttribute("data-termly-config", "");
    configScript.type = "text/javascript";
    configScript.src = "/config/termly.js";
    document.head.appendChild(configScript);

    const termlyScript = document.createElement("script");
    termlyScript.type = "text/javascript";
    termlyScript.src =
      "https://app.termly.io/resource-blocker/a7db239c-ed1c-4f30-93d7-35a27fca4dac?autoBlock=on";
    document.head.appendChild(termlyScript);

    return () => {
      if (document.head.contains(configScript)) {
        document.head.removeChild(configScript);
      }
      if (document.head.contains(termlyScript)) {
        document.head.removeChild(termlyScript);
      }
    };
  }, []);

  return null;
};
